enum VEHICLE_TYPE_FILTER {
    INCLUDE = 1,
    ONLY,
    WITHOUT,
}

export default VEHICLE_TYPE_FILTER;
